export const WALLET_STORAGE_KEY = 'selectedWalletRdns';
